"use strict";
/**
 * Notification API Types
 *
 * Types for user notification system.
 *
 * Derivation:
 * - NotificationItem: derived from NotificationRecord via SanitizedRecord.
 *   The toClientNotification() function in lambda-secure/src/services/notifications.ts
 *   strips DynamoDB keys and returns the remaining fields directly.
 * - UnreadNotificationCountResponse: remains standalone because getUnreadCounts()
 *   remaps field names (unread_count → count, unread_patterns → patterns, etc.)
 *   which cannot be expressed with Pick/Omit. Documents mapping from
 *   NotificationUnreadCounterRecord.
 */
Object.defineProperty(exports, "__esModule", { value: true });
